import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProjectLocation.css';
import showToast from '../../components/ShowToast';
import OnboardingProgressBar from '../../components/Projects/OnboardingProgressBar';
import ModernNavbarPureCSS from '../../components/Navbar/ModernNavBarPureCSS';
import { jwtDecode } from 'jwt-decode';
import LocationInputGroup from '../../components/Form/LocationInputGroup';

const ProjectLocation = () => {
    const { templateId } = useParams();
    const navigate = useNavigate();
    const [postcode, setPostcode] = useState('');
    const [suburb, setSuburb] = useState('');
    const [state, setState] = useState('');
    const [locationDisplay, setLocationDisplay] = useState('');
    const [username, setUsername] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUsername(decoded.UserName || decoded.unique_name || 'User');
            } catch (e) {
                console.error("Token decode error", e);
            }
        }
    }, []);

    const handleLocationSelect = (loc) => {
        setPostcode(loc.postcode || '');
        setSuburb(loc.suburb || '');
        setState(loc.state || '');
        setLocationDisplay(loc.fullAddress || '');
    };

    const handleNext = () => {
        if (!postcode || postcode.length < 3) {
            showToast('error', 'Please enter a suburb or postcode');
            return;
        }
        // Pass postcode, suburb, and state to the next step
        navigate(`/ai-project-onboarding/confirm-contractors/${templateId}?postcode=${postcode}&suburb=${encodeURIComponent(suburb)}&state=${encodeURIComponent(state)}`);
    };

    return (
        <div style={{minHeight: '100vh', backgroundColor: '#f9fafb', display: 'flex', flexDirection: 'column', paddingTop: '60px'}}>
            <ModernNavbarPureCSS UserName={username} />
            
            {/* Gold Subtitle Bar */}
            <div style={{
                background: 'linear-gradient(to bottom, #d4af37 0%, #f9e68c 30%, #c49c25 60%, #8a6e14 100%)',
                padding: '1.5rem 2rem',
                borderTop: '1px solid #fffae0',
                borderBottom: '1px solid #49310a',
                color: 'white',
                marginBottom: '2rem'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: '600', color: '#011746' }}>Where is your project located?</h1>
                        <p style={{ margin: '0.25rem 0 0 0', color: '#011746', opacity: 0.9 }}>Your postcode helps us estimate costs and find local professionals.</p>
                    </div>
                    <button 
                        onClick={() => navigate('/projects')}
                        style={{
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: '1px solid rgba(255, 255, 255, 0.4)',
                            color: '#011746',
                            padding: '0.5rem 1rem',
                            borderRadius: '0.375rem',
                            cursor: 'pointer',
                            fontSize: '0.9rem',
                            fontWeight: '600',
                            transition: 'all 0.2s'
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>

        <div className="pageContainer">
            <div className="onboarding-container">
                <OnboardingProgressBar currentStep={2} />
                
                <div className="step-content">

                    <div style={{ maxWidth: '400px', margin: '30px auto' }}>
                        <LocationInputGroup 
                            label={null}
                            value={locationDisplay}
                            onLocationSelect={handleLocationSelect}
                            suburb={suburb}
                            state={state}
                            placeholder="Enter your suburb, postcode or region"
                        />
                    </div>

                    <div className="onboarding-nav">
                        <button onClick={() => navigate(-1)} className="nav-button secondary">Back</button>
                        <button onClick={handleNext} className="nav-button primary">Next</button>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default ProjectLocation;
